import React, { useEffect, useState } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';
import { Box } from '@mui/system';

import {
  getPubliclyAvailableShifts,
  Language,
  preLoginLang,
  publicAvailableShifts,
  setPreLoginLangWeb,
  successSelector,
  utilActions,
} from '@pharmaplan/common';

import { Settings } from 'luxon';
import { useAppSelector } from '../../hooks/useAppSelector';
import { IDynamicTableObject } from '../DynamicTable/types';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { Constants } from '../../helpers/Constants';
import DynamicTable from '../DynamicTable';
import strings from '../../localization';

import { availableShiftHeader, availableShiftMapper } from './helper';
import PublicShiftHeader from './PublicShiftHeader';
import styles from './styles';

const { login, availableShiftsFrench, availableShifts } = Constants.paths;
const { fr, en } = Language;

const PublicAvailableShifts = () => {
  const dispatch = useAppDispatch();
  const [page, setPage] = useState(1);

  const { pathname } = useLocation();
  const landingLanguage = {
    [availableShifts]: en,
    [availableShiftsFrench]: fr,
  };

  const language = useAppSelector(preLoginLang);
  const isFrench = language === fr;

  const handleLanding = () => {
    const lang = landingLanguage[pathname];
    dispatch(setPreLoginLangWeb(lang));
    Settings.defaultLocale = lang;
  };

  const shifts = useAppSelector(publicAvailableShifts);
  const navigate = useNavigate();

  const loadSuccess = useAppSelector((state) =>
    successSelector([utilActions.getPubliclyAvailableShifts], state));

  const { data, totalCount } = shifts ?? {};

  const handleNavigate = () => {
    navigate(login);
  };

  useEffect(() => {
    dispatch(getPubliclyAvailableShifts({ pagingModel: { page: 1 } }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const table: IDynamicTableObject = {
    title: strings.availableWorkshift,
    rows: availableShiftMapper(data, handleNavigate, isFrench),
    headers: availableShiftHeader(),
    headerBar: [],
  };

  const handlePagination = (_: unknown, selectedPage: number) => {
    setPage(selectedPage + 1);
    dispatch(
      getPubliclyAvailableShifts({ pagingModel: { page: selectedPage + 1 } }),
    );
  };

  useEffect(() => {
    handleLanding();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={styles.container}>
      <Box sx={styles.subContainer}>
        <DynamicTable
          customHeader={<PublicShiftHeader />}
          stickyHeader
          showHeader={false}
          noContainerStyling
          customContainerStyle={styles.table}
          table={table}
          loadSuccess={loadSuccess}
          handlePagination={handlePagination}
          page={page}
          totalCount={totalCount}
        />
      </Box>
    </Box>
  );
};

export default PublicAvailableShifts;
